import { render, staticRenderFns } from "./ChooseDeadline.vue?vue&type=template&id=1261e8a0&scoped=true&lang=pug"
import script from "./ChooseDeadline.vue?vue&type=script&lang=js"
export * from "./ChooseDeadline.vue?vue&type=script&lang=js"
import style0 from "./ChooseDeadline.vue?vue&type=style&index=0&id=1261e8a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1261e8a0",
  null
  
)

export default component.exports